enum TrustedPortalRealtimeAPIEventTypeEnum {
  TrustedPortalEventCreatedNotification = 'TrustedPortalEventCreatedNotification',
}

export default TrustedPortalRealtimeAPIEventTypeEnum;
